import './App.scss'
import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { Col, Container, Row, Button, Alert } from 'react-bootstrap'
import { Step1 } from './Screens/Step1/Step1'
import { Step2 } from './Screens/Step2/Step2'
import { Step3 } from './Screens/Step3/Step3'
import { Step4 } from './Screens/Step4/Step4'
import { Step5 } from './Screens/Step5/Step5'
import { Step6 } from './Screens/Step6/Step6'
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute'
import config from './config'

function App() {
  const [isEnabled, setIsEnabled] = useState(true)
  const [globalMigrationStatus, setGlobalMigrationStatus] = useState(null)
  const location = useLocation()
  const navigate = useNavigate()
  const getUserPermissions = async () => {
    try {
      const data = await fetch(`${config.BACKEND_URL}/checkBothTokens`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }).then(async (data) => {
        const resp = await data.json()
        setIsEnabled(resp.success)
        return resp.success
      })
      return data
    } catch (error) {
      console.log('Connection error', error)
    }
  }

  useEffect(() => {
    getUserPermissions()
  }, [location])

  useEffect(() => {
    document.title = 'Workfront Migration Utility'
  }, [])

  // Check for active migration periodically - ONLY on Step1 and Step6
  useEffect(() => {
    // Only check on Step1 and Step6 to avoid blocking other screens
    const shouldCheck = location.pathname === '/step1' || location.pathname === '/step6'
    
    if (!shouldCheck) {
      setGlobalMigrationStatus(null)
      return
    }

    const checkMigration = async () => {
      // Only check if user is authenticated
      if (!isEnabled) {
        return
      }
      
      try {
        const response = await fetch(`${config.BACKEND_URL}/migrate/migrationStatus`, {
          headers: {
            'ngrok-skip-browser-warning': '69420',
          },
          credentials: 'include',
        })
        if (response.ok) {
          const data = await response.json()
          if (data.status === 'in_progress') {
            setGlobalMigrationStatus(data)
          } else {
            setGlobalMigrationStatus(null)
          }
        } else {
          // 404 or other error - no active migration
          setGlobalMigrationStatus(null)
        }
      } catch (error) {
        // Network error or other issue - silently fail
        setGlobalMigrationStatus(null)
      }
    }

    // Check immediately
    checkMigration()

    // Then check every 5 seconds
    const interval = setInterval(checkMigration, 5000)
    return () => clearInterval(interval)
  }, [isEnabled, location.pathname])

  return (
    <div className="App">
      <div className="app_container w-lg-100">
        {/* Global Migration Status Banner */}
        {globalMigrationStatus?.status === 'in_progress' && location.pathname !== '/step6' && (
          <Alert 
            variant="info" 
            className="mb-0 text-center" 
            style={{ 
              borderRadius: 0, 
              position: 'sticky', 
              top: 0, 
              zIndex: 1000,
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none'
            }}
          >
            <div className="d-flex justify-content-center align-items-center gap-3">
              <span>
                🔄 <strong>Migration in progress:</strong> {globalMigrationStatus.overallPercentage || 0}% complete
                ({globalMigrationStatus.completedProjects || 0}/{globalMigrationStatus.totalProjects || 0} projects)
              </span>
              <Button 
                size="sm" 
                variant="outline-primary"
                onClick={() => navigate('/step6')}
              >
                View Status
              </Button>
            </div>
          </Alert>
        )}
        <Container fluid style={{ height: '100%', overflowY: 'auto' }} className="py-4">
          <Row className="mt-2">
            <Col lg={1}></Col>
            <Col xs={12} lg={10}>
              <Routes>
                <Route exact path="/step1" element={<Step1 />} />
                <Route exact path="/step2" element={<Step2 />} />
                <Route
                  exact
                  path="/step3"
                  element={
                    <ProtectedRoute isAuthenticated={isEnabled}>
                      <Step3 />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/step4"
                  element={
                    <ProtectedRoute isAuthenticated={isEnabled}>
                      <Step4 />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/step5"
                  element={
                    <ProtectedRoute isAuthenticated={isEnabled}>
                      <Step5 />
                    </ProtectedRoute>
                  }
                />
                <Route
                  exact
                  path="/step6"
                  element={
                    <ProtectedRoute isAuthenticated={isEnabled}>
                      <Step6 />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Col>
            <Col xs={1}></Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}
export default App
